import {useEffect, useRef} from 'react';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import {Typography, Stack, IconButton, List, ListSubheader, Divider, Box} from '@mui/material';
import {useRecentActions} from "../context/RecentActionContext";
import LinearProgressWithLabel from "../legal/[caseId]/repo/status-bar/LinearWithValueLabel";
import {StatusType} from "../../../components/StatusType";
import ClearIcon from "@mui/icons-material/Clear";
import {useTranslation} from "react-i18next";
import DrawersController from './DrawersControler';

export default function ActionsDrawer({setOpenUserDrawer, setOpenMenu, openMenu, openUserDrawer}) {
    const {actions, removeActionById, openDrawer, setOpenDrawer, changeOpenDrawer} = useRecentActions();
    const actionsRef = useRef(actions);
    const {t} = useTranslation("status");

    const formatFileSize = (size) => {
        if(size < 1024) return `${size} B`;
        if(size < 1048576) return `${(size / 1024).toFixed(1)} KB`;
        if(size < 1073741824) return `${(size / 1048576).toFixed(1)} MB`;
        return `${(size / 1073741824).toFixed(1)} GB`;
    };

    const getStatusBarColor = (status) => {
        switch(status) {
            case StatusType.SUCCESS:
            case StatusType.DELETE_FILE_SUCCESS:
            case StatusType.ADD_NEW_DIRECTORY_SUCCESS:
                return 'success';
            case StatusType.ERROR:
            case StatusType.DELETE_FILE_ERROR:
            case StatusType.ADD_NEW_DIRECTORY_ERROR:
                return 'error';
            default:
                return 'primary';
        }
    };

    useEffect(() => {
        actionsRef.current = actions;
    }, [actions]);

    const list = () => (
        <Box
            role="case-menu"
            sx={{backgroundColor: 'primary.main', height: '100%'}}
        >
            <List
                sx={{width: {xs: '100vw', sm: '55vw', md: '35vw', lg: '20vw'}, justifyContent: 'flex-end', alignItems: 'center', marginRight: 1, height: '100%'}}
                subheader={
                    <ListSubheader component="div" sx={{backgroundColor: 'primary.main'}}>
                        <DrawersController setOpenDrawer={setOpenDrawer} setOpenUserDrawer={setOpenUserDrawer} setOpenMenu={setOpenMenu}  openMenu={openMenu} openDrawer={openDrawer} openUserDrawer={openUserDrawer}/>
                        <Divider />
                        <Typography variant="h5" textAlign={'center'}>{t('common:actions-panel.title')}</Typography>
                    </ListSubheader>}
            >
                {actions.length === 0 ? (
                    <Stack sx={{alignItems: 'center', margin: 2}}>
                        <Typography>{t('common:actions-panel.content')}</Typography>
                    </Stack>
                ) : (
                    <Stack spacing={2} sx={{padding: 4}}>
                        {actions.map((action) => (
                            <Box key={action.id}>
                                <IconButton
                                    onClick={() => removeActionById(action.id)}
                                    size="small"
                                    style={{float: 'right'}}
                                    title={t('common:actions-panel.remove')}>
                                    <ClearIcon />
                                </IconButton>
                                <Typography sx={{textWrap: 'wrap', wordBreak: 'break-all'}}>{action.name}</Typography>
                                <LinearProgressWithLabel color={getStatusBarColor(action.status)} value={action.progress} />
                                <Typography>{t('common:actions-panel.status', {status: t(StatusType[action.status])})}</Typography>
                                {action.size > 0 && (
                                    <Typography>{t('common:actions-panel.sended', {progressSize: formatFileSize((action.size * action.progress) / 100), size: formatFileSize(action.size), progress: action.progress})}</Typography>
                                )}
                            </Box>
                        ))}
                    </Stack>
                )}
            </List>
        </Box>
    );

    return (
        <>
            <SwipeableDrawer
                open={openDrawer}
                onClose={() => setOpenDrawer(false)}
                onOpen={() => setOpenDrawer(true)}
                anchor='right'>
                {list()}
            </SwipeableDrawer>
        </>
    );
}